import React from 'react';
import { useSelector } from 'react-redux';
import { useController, useFormContext } from 'react-hook-form';
import PriceInputWithEarnings from '@wix/da-shared-react/pkg/DollarPriceInput/variants/PriceInputWithEarnings';
import { getMaxPrice } from '@wix/da-shared-react/pkg/redux/shared/selectors';

interface Props {
  label: string;
  fieldName: string;
  productType: React.ComponentProps<typeof PriceInputWithEarnings>['productType'];
  min: number;
}

const PriceField: React.FC<Props> = ({ label, fieldName, productType, min }) => {
  const maxPrice = useSelector(getMaxPrice);
  const { control, errors } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: fieldName, control });
  const error = errors[fieldName];

  return (
    <PriceInputWithEarnings
      label={label}
      value={value}
      error={error?.message}
      validationResult={error ? 'error' : undefined}
      onChange={onChange}
      min={min}
      max={maxPrice}
      forceInteger
      isRequired
      noBottomSpacing
      productType={productType}
    />
  );
};
PriceField.displayName = 'PriceField';

export default PriceField;
